<template>
  <div class="sketch-container" ref="pickerContainer">
    <div class="sketch-indicator" @click="preventOpen">
      <div class="color-indicator" :style="{ background: selectedColor }" />
      <span class="label">{{ label }}</span>
    </div>
    <div :class="['picker', { colorOpened: opened }, openDirection]">
      <div class="picker-container">
        <div class="arrow"></div>
        <Chrome :value="selectedColor" @input="submitColor" />

        <div class="actions">
          <button @click="cancel()">
            {{ $t('cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chrome } from 'vue-color'

export default {
  name: 'ColorPicker',
  i18nOptions: { keyPrefix: 'shared.color-picker' },
  components: { Chrome },
  props: {
    label: {
      type: String,
      default: '#FFFFFF',
    },
    color: {
      type: String,
      default: '#FFFFFF',
    },
    openDirection: {
      type: String,
      default: 'right',
    },
  },
  data() {
    return {
      selectedColor: this.color,
      opened: false,
      changes: true,
    }
  },
  watch: {
    color() {
      this.selectedColor = this.color
    },
  },
  methods: {
    submitColor(newColor) {
      this.selectedColor = newColor

      if (!this.selectedColor.hex8) {
        return
      }
      this.$emit('submit', this.selectedColor.hex8)
    },
    cancel() {
      this.opened = false
      this.changes = false
      this.selectedColor = this.color
    },
    preventOpen() {
      setTimeout(() => {
        this.opened = true
        this.changes = true
      })
    },
  },
  updated() {
    document.onclick = e => {
      const picker = document.getElementsByClassName(`colorOpened`)
      if (picker.length && !e.path.includes(picker[0])) {
        this.opened = false
        this.changes = true
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.sketch-container {
  position: relative;
  margin-top: 16px;

  .sketch-indicator {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: fit-content;
    cursor: pointer;
  }

  .color-indicator {
    height: 30px;
    width: 30px;
    border-radius: 5px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    margin-right: 10px;
  }

  .picker {
    display: none;
    position: absolute;
    z-index: 20;
    top: 45px;

    &.right {
      left: 0;

      .arrow {
        left: 10px;
      }
    }

    &.left {
      right: 0;

      .arrow {
        right: 62px;
      }
    }

    background: white;
    width: 220px;
    padding: 0;

    justify-content: center;
    align-items: center;
    flex-direction: column;

    box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.15);
    border-radius: 2px;

    .picker-container {
      position: relative;

      .arrow {
        width: 10px;
        height: 10px;
        border-top: 2px solid #fff;
        border-left: 2px solid #fff;
        background: #fff;
        transform: rotate(45deg);
        box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.15);
        top: -5px;
        z-index: 0;
        position: absolute;
        border-radius: 2px;
      }
    }

    .actions {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;
      margin-top: 10px;

      button {
        width: 100%;
        color: black;
        padding: 10px;
        border: none;
        outline: none;
        cursor: pointer;
        background: white;
      }
    }

    &.colorOpened {
      display: flex;
    }
  }
}
</style>
